import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  handleAPIErrorToast,
  loadingToast,
  successToast,
} from "@/component/toasts";
import {
  createServiceUser,
  deleteServiceUser,
  getServiceUser,
  getServiceUserByIdAsync,
  updateServiceUser,
} from "@/services/service-users";
import { getZonesAsync } from "@/services/zones";

export const getZoneOptionsAsync = createAsyncThunk(
  "serviceUsersReducer/getZoneOptions",
  async () => {
    try {
      const response = await getZonesAsync();
      return response.data;
    } catch (error: any) {
      handleAPIErrorToast(error);
      throw new Error("Failed to fetch data");
    }
  }
);

export const getMoreServiceUsersAsync = createAsyncThunk(
  "service-user/getServiceUsers",
  async (payload: {
    page: number;
    query: string;
    limit: number | string;
    zone?: any;
    status?: any;
  }) => {
    try {
      const response = await getServiceUser(payload);
      return response.data;
    } catch (error: any) {
      handleAPIErrorToast(error);
      throw new Error("Failed to fetch data");
    }
  }
);

export const getServiceUsersAsync = createAsyncThunk(
  "service-user/getServiceUsersBySearch",
  async (payload: {
    page: number;
    query: string;
    limit: number | string;
    zone?: any;
    status?: any;
    including?: string;
  }) => {
    try {
      const response = await getServiceUser(payload);
      return response.data;
    } catch (error: any) {
      handleAPIErrorToast(error);
      throw new Error("Failed to fetch data");
    }
  }
);

export const getOneServiceUserAsync = createAsyncThunk(
  "service-user/getServiceUserById",
  async (id: string) => {
    try {
      const response = await getServiceUserByIdAsync(id);
      return response.data;
    } catch (error: any) {
      handleAPIErrorToast(error);
      throw new Error("Failed to fetch data");
    }
  }
);

export const createServiceUserAsync = createAsyncThunk(
  "service-user/createServiceUser",
  async (data: any, { rejectWithValue }) => {
    let response;
    try {
      response = await createServiceUser(data);
      successToast("Service User created successfully");
      return response.data;
    } catch (error: any) {
      throw rejectWithValue(error);
    }
  }
);

export const updateServiceUserAsync = createAsyncThunk(
  "service-user/updateServiceUser",
  async ({ id, data }: any, { rejectWithValue }) => {
    let response;
    loadingToast("Updating Service User");
    try {
      response = await updateServiceUser(id, data);
      return {
        ...response.data,
        data: {
          id: response.data.data.id,
          _id: response.data.data.id,
          name: response.data.data.name,
          avatar: response.data.data.avatar,
          firstName: response.data.data.firstName,
          middleName: response.data.data.middleName,
          lastName: response.data.data.lastName,
          zone: response.data.data.zone,
          status: response.data.data.status,
        },
      };
    } catch (error: any) {
      throw rejectWithValue(error);
    }
  }
);

export const deleteServiceUserAsync = createAsyncThunk(
  "service-user/deleteServiceUser",
  async (id: string) => {
    let response;
    loadingToast("Deleting Shift Passcode");
    try {
      response = await deleteServiceUser(id);
      successToast("Service User deleted successfully");
      return response.data;
    } catch (error: any) {
      handleAPIErrorToast(error);
      throw new Error("Failed to fetch data");
    }
  }
);
